import * as angular from 'angular';
import * as _ from 'lodash';

import { ApprovalSettings, ComponentDefinition, ContextualField, IApprovalStrategy, KeyValuePair, PropertyType } from '../../../models';
import { toggleEditMode } from '../../../common';

class ModernApprovalConfigurationContextualController implements angular.IComponentController {
    approvalLevels: KeyValuePair<number, string>[];
    formController: angular.IFormController;
    isSaving: boolean;
    model: ApprovalSettings;
    properties: ContextualField[];

    readonly approvalStrategy: IApprovalStrategy;
    readonly externalFormController: angular.IFormController;
    readonly onSave: (value: { model: any }) => angular.IPromise<any>;
    readonly returnParams: any;
    readonly seriesCollection: { model: any, originalSeries: any }[];

    static $inject = ['$rootScope', '$state'];

    constructor(private _$rootScope: angular.IRootScopeService,
        private _$state: angular.ui.IStateService) {
    }

    $onInit() {
        this.properties = [
            {
                label: 'Show tree',
                modelName: 'isTreeMode',
                propertyName: 'isTreeModeProperty',
                propertyType: PropertyType.Boolean,
                icon: 'fa-sitemap fa-rotate-270',
                required: false
            },
            {
                label: 'Global approval',
                modelName: 'globalApprovalLevels',
                propertyName: 'globalApprovalLevelsProperty',
                propertyType: PropertyType.MultiSelect,
                icon: ['fa-thumbs-o-up', 'fa-arrows-v'],
                extraData: {
                    options: []
                }
            },
            {
                label: 'Disable individual approval',
                modelName: 'isDisableIndividualApproval',
                propertyName: 'isDisableIndividualApprovalProperty',
                propertyType: PropertyType.Boolean,
                icon: ['fa-thumbs-o-up', 'fa-minus'],
                required: false
            }
        ];
        this.setLevels();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj['approvalStrategy'] && this.approvalStrategy) {
            this.setLevels();
        }
    }

    private setLevels() {
        if (this.properties && this.approvalStrategy) {
            const approvalLevels = this.approvalStrategy
                .approbationStrategyLevelCollection
                .map(l => {
                    return { key: l.level, value: `L${(l.level + 1)}` };
                });
            this.properties[1].extraData.options = approvalLevels;
        }
    }

    save() {
        if (this.onSave) {
            this.isSaving = true;
            this.model.series = _.chain(this.seriesCollection).map(d => d.model).flatten().value();
            this.onSave({ model: this.model })
                .then(() => {
                    this._$rootScope.$broadcast(toggleEditMode);
                    this.formController.$setPristine();
                    this.externalFormController.$setPristine();
                    this._$state.go('approval', this.returnParams);
                })
                .finally(() => this.isSaving = false);
        }
    }

    cancel() {
        this._$rootScope.$broadcast(toggleEditMode);
        this.formController.$setPristine();
        this.externalFormController.$setPristine();
        this._$state.go('approval', this.returnParams);
    }
}

export const wtModernApprovalConfigurationContextual: ComponentDefinition = {
    componentId: 'wtModernApprovalConfigurationContextual',
    controller: ModernApprovalConfigurationContextualController,
    template: require('./modernApprovalConfigurationContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        approvalStrategy: '<',
        externalFormController: '<',
        model: '=',
        onSave: '&',
        returnParams: '<',
        seriesCollection: '='
    }
};
